export enum TransactionStatus {
  INITIALIZED = 'INITIALIZED',
  APPROVE_REQUIRED = 'APPROVE_REQUIRED',
  APPROVE_IN_PROGRESS = 'APPROVE_IN_PROGRESS',
  CONFIRMATION_REQUIRED = 'CONFIRMATION_REQUIRED',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}
